<app-dialog
  #dialog
  [key]="dialogKey"
  [action]="'mtm-daily'"
  [headerTheme]="'simple'"
  [showMaximizeButton]="true"
  [startMaximized]="true"
  [title]="'MtM Diário'"
  [icon]="'pi pi-chart-line'"
  [maxWidth]="'95vw'"
  [minHeight]="'50vh'"
  (onClose)="close()">
  <div class="mtm-daily-container">
    <div class="loading-overlay" *ngIf="isLoading">
      <app-cog-loading-spinner />
      <span>Carregando dados...</span>
    </div>

    <!-- Alerta de conformidade de mandato (não-bloqueante, avaliado 1x ao abrir) -->
    <app-mandate-compliance-alert
      *ngIf="!isLoading"
      [violations]="mandateViolations"
      [mandateResolved]="mandateResolved"
      [companyName]="operation?.company?.displayName || ''"
      [referenceDate]="operation?.operationDate || null">
    </app-mandate-compliance-alert>

    <ng-container *ngIf="!isLoading">
      <!-- Informações fixas da operação -->
      <div class="operation-info-cards" *ngIf="operationInfo">
        <!-- Cards comuns a todos os tipos -->
        <div class="info-card">
          <span class="info-label">Notional</span>
          <span class="info-value">{{ operationInfo.notional | vaultFormatCurrency: 2 }}</span>
        </div>
        <div class="info-card" *ngIf="operationInfo.dataOperacao">
          <span class="info-label">Data Operação</span>
          <span class="info-value">{{ operationInfo.dataOperacao | vaultDate }}</span>
        </div>
        <div class="info-card" *ngIf="operationInfo.dataVencimento">
          <span class="info-label">Data Vencimento</span>
          <span class="info-value">{{ operationInfo.dataVencimento | vaultDate }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">Spot</span>
          <span class="info-value">{{ operationInfo.spot | vaultFormatCurrency: 4 }}</span>
        </div>

        <!-- Cards específicos para NDF (com ou sem CAP) -->
        <ng-container *ngIf="isNdf">
          <div class="info-card">
            <span class="info-label">Forward</span>
            <span class="info-value">{{ operationInfo.forward | vaultFormatCurrency: 4 }}</span>
          </div>
          <div class="info-card" *ngIf="hasCap">
            <span class="info-label">CAP</span>
            <span class="info-value">{{ operationInfo.cap | vaultFormatCurrency: 4 }}</span>
          </div>
        </ng-container>

        <!-- Cards específicos para Call Spread -->
        <ng-container *ngIf="isCallSpread">
          <div class="info-card">
            <span class="info-label">Strike Call Comprada</span>
            <span class="info-value">{{
              operationInfo.strikeCallComprada | vaultFormatCurrency: 4
            }}</span>
          </div>
          <div class="info-card">
            <span class="info-label">Strike Call Vendida</span>
            <span class="info-value">{{
              operationInfo.strikeCallVendida | vaultFormatCurrency: 4
            }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="isPutSpread">
          <div class="info-card">
            <span class="info-label">Strike Put Comprada</span>
            <span class="info-value">{{
              operationInfo.strikePutComprada | vaultFormatCurrency: 4
            }}</span>
          </div>
          <div class="info-card">
            <span class="info-label">Strike Put Vendida</span>
            <span class="info-value">{{
              operationInfo.strikePutVendida | vaultFormatCurrency: 4
            }}</span>
          </div>
        </ng-container>

        <!-- Cards específicos para Call Vanilla -->
        <ng-container *ngIf="isCallVanilla">
          <div class="info-card">
            <span class="info-label">Strike Call</span>
            <span class="info-value">{{ operationInfo.strikeCall | vaultFormatCurrency: 4 }}</span>
          </div>
          <div class="info-card" *ngIf="operationInfo.direcao">
            <span class="info-label">Direção</span>
            <span class="info-value">{{ operationInfo.direcao }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="isPutVanilla">
          <div class="info-card">
            <span class="info-label">Strike Put</span>
            <span class="info-value">{{ operationInfo.strikePut | vaultFormatCurrency: 4 }}</span>
          </div>
        </ng-container>
      </div>

      <!-- Tabela de MtM diário -->
      <div class="mtm-daily-content" *ngIf="data.length > 0">
        <app-table
          [items]="getItems()"
          [columnDefinitions]="columnDefinitions"
          [sortable]="true"
          [hasPagination]="false"
          [showSearch]="false"
          (sendTableSort)="handleTableSort($event)">
          <ng-template appNamedTemplate="dataReferencia" let-item>
            {{ item.mtmData?.mtmDetails?.dataReferencia || '-' }}
          </ng-template>
          <ng-template appNamedTemplate="mtmAdjustedBalance" let-item>
            {{
              (item.mtmAdjustedBalance ?? null) !== null
                ? (item.mtmAdjustedBalance | vaultFormatCurrency: 2)
                : '-'
            }}
          </ng-template>
        </app-table>
      </div>

      <!-- Estado vazio -->
      <div class="empty-state" *ngIf="data.length === 0">
        <ng-container *ngIf="!isGenerating; else generatingState">
          <i class="pi pi-info-circle"></i>
        </ng-container>
        <ng-template #generatingState>
          <app-cog-loading-spinner />
        </ng-template>
        <p>Nenhum dado de MtM diário encontrado para esta operação.</p>
        <!-- Card 3902: gerar grava o MtM (POST mtm-daily/{id}/generate, DerivativeCalculator.CREATE). -->
        @if (actionPermissions.canCreate()) {
          <app-button
            [label]="'Gerar MtM Diário'"
            [icon]="'pi pi-calculator'"
            [severity]="'primary'"
            [isLoading]="isGenerating"
            [loadingText]="'Gerando MtM Diário...'"
            [disabled]="isGenerating"
            (sendButtonClick)="generateMtmDaily()">
          </app-button>
        }
      </div>
    </ng-container>
  </div>

  <ng-template #footer></ng-template>
</app-dialog>
